var trackingEvent = require('src/interlock/no-ui/tracking/event');
var constant = require('src/interlock/no-ui/tracking/constant');

module.exports = {
    homepage_click: trackingEvent.actionCompleted(
        constant.ACTION_RESET_NAVIGATION, constant.ACTION_RESET_NAVIGATION),

    nav_mmy_select_new_car: trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.NEW_CAR_SELECT),

    nav_mmy_select_used_car: trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.USED_CAR_SELECT),

    nav_mmy_select_new_car_start: trackingEvent.actionStart(
        constant.ACTION_MMY_SELECT, constant.NEW_CAR_SELECT),

    nav_mmy_select_used_car_start: trackingEvent.actionStart(
        constant.ACTION_MMY_SELECT, constant.USED_CAR_SELECT),

    nav_mmy_select_make: trackingEvent.actionProgress(
        constant.ACTION_MMY_SELECT, constant.MAKE_SELECT),

    nav_mmy_model_select: trackingEvent.actionProgress(
        constant.ACTION_MMY_SELECT, constant.MODEL_SELECT),

    nav_mmy_year_select: trackingEvent.actionEnd(
        constant.ACTION_MMY_SELECT, constant.YEAR_SELECT),

    nav_mmy_select_submit_make: trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.SUBMIT_MAKE),

    nav_mmy_select_car_types : trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.CAR_TYPES),

    nav_mmy_select_cars_for_sale : trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.CARS_FOR_SALE),

    nav_mmy_select_research : trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.RESEARCH),

    nav_type_select: trackingEvent.actionCompleted(
        constant.ACTION_TYPE_SELECT, constant.ACTION_TYPE_SELECT),

    nav_inventory_select_new_used: trackingEvent.actionCompleted(
        constant.ACTION_INVENTORY_SELECT, constant.NEW_USED_CAR_SELECT),

    nav_inventory_select_type: trackingEvent.actionCompleted(
        constant.ACTION_INVENTORY_SELECT, constant.ACTION_TYPE_SELECT),

    nav_inventory_select_make: trackingEvent.actionCompleted(
        constant.ACTION_INVENTORY_SELECT, constant.MAKE_SELECT)
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/tracking/maps/common/nav.js
// module id = 86
// module chunks = 0 1 2 3 4 5 6 7 8 9 11 12 13 14